var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome3Fill1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 16.6667C16.6668 16.8877 16.579 17.0996 16.4228 17.2559C16.2665 17.4122 16.0545 17.5 15.8335 17.5H4.16683C3.94582 17.5 3.73385 17.4122 3.57757 17.2559C3.42129 17.0996 3.3335 16.8877 3.3335 16.6667V9.16667H0.833496L9.43933 1.34334C9.59275 1.20374 9.79273 1.12637 10.0002 1.12637C10.2076 1.12637 10.4076 1.20374 10.561 1.34334L19.1668 9.16667H16.6668V16.6667ZM6.66683 12.5V14.1667H13.3335V12.5H6.66683Z",
    fill: "#2A2B79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome3Fill1);
export default __webpack_public_path__ + "static/media/home-3-fill 1.3f0102f69c262990b09fb560f59e4ec1.svg";
export { ForwardRef as ReactComponent };